import { render } from "./ClassificationList.vue?vue&type=template&id=5251ed08&scoped=true&ts=true"
import script from "./ClassificationList.vue?vue&type=script&lang=ts"
export * from "./ClassificationList.vue?vue&type=script&lang=ts"

import "./ClassificationList.vue?vue&type=style&index=0&id=5251ed08&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5251ed08"]])

export default __exports__